import { gql } from '@apollo/client';
import * as MENUS from '@/constants/menus';
import { SiteInfoFragment } from '../fragments/GeneralSettings';
import { EditorBlocks } from '../fragments/EditorBlocks';
import { Header, HeaderNavigationMenu, FooterNavigationMenu, SEO, DisclosureBlock, GlobalElements, Subnav, Container } from '@/components';
import { flatListToHierarchical } from '@faustwp/core';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { usePageLoadActions } from '@/hooks/usePageLoadActions';
import Script from 'next/script';

export default function Component(props) {
	// Loading state for previews
	if (props.loading) {
		return <>Loading...</>;
	}

	const { title: siteTitle, description: siteDescription } = props?.data?.generalSettings;
	const { editorBlocks } = props.data.page;
	const blockList = flatListToHierarchical(editorBlocks, { childrenKey: 'innerBlocks' });
	const headerMenuItems = props?.data?.headerMenuItems?.nodes ?? [];
	const footerMenuItems = props?.data?.footerMenuItems?.nodes ?? [];
	const { featuredImage, seo, disclosures, navigationSettings, title } = props?.data?.page;

	usePageLoadActions();

	return (
		<GlobalElements siteTitle={siteTitle} siteDescription={siteDescription} seo={seo} featuredImageUrl={featuredImage?.node?.sourceUrl} headerMenuItems={headerMenuItems} navigationSettings={navigationSettings} footerMenuItems={footerMenuItems} disclosures={disclosures} pageTitle={title}>
			<WordPressBlocksViewer blocks={blockList} />
			<Container>
				<section style={{'paddingBlock': '3rem'}}>
					<div id="ashby_embed"></div>
				</section>
			</Container>
			<Script src="https://jobs.ashbyhq.com/Netspend-Careers-Page/embed?version=2"></Script>
		</GlobalElements>
	);
}

Component.variables = (seed, ctx) => {
	return {
		databaseId: seed.databaseId,
		headerLocation: MENUS.HEADER_NAV,
		headerMobileCtaLocation: MENUS.HEADER_MOBILE_CTAS,
		footerLocation: MENUS.FOOTER_NAV,
		debitSubnavLocation: MENUS.DEBIT_NAV,
		prepaidSubnavLocation: MENUS.PREPAID_NAV,
		insuranceSubnavLocation: MENUS.INSURANCE_NAV,
		asPreview: ctx?.asPreview,
	};
};

Component.query = gql`
	${SiteInfoFragment}
	${EditorBlocks}
	${Header.fragments.entry}
	${HeaderNavigationMenu.fragments.entry}
	${FooterNavigationMenu.fragments.entry}
	${Subnav.fragments.entry}
	${DisclosureBlock.fragments.entry}
	${SEO.fragments.entry}
	query GetPageData($databaseId: ID!, $headerLocation: MenuLocationEnum, $footerLocation: MenuLocationEnum, $debitSubnavLocation: MenuLocationEnum, $prepaidSubnavLocation: MenuLocationEnum, $insuranceSubnavLocation: MenuLocationEnum, $asPreview: Boolean = false) {
		page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
			title
			seo {
				...PageSeo
			}
			disclosures {
				...PageDisclosuresFragment
			}
			navigationSettings {
				...PageNavigationSettings
			}
			editorBlocks {
				...AllBlocks
			}
		}
		generalSettings {
			...SiteInfoFragment
		}
		headerMenuItems: menuItems(first: 100, where: { location: $headerLocation }) {
			nodes {
				...HeaderNavigationMenuItemFragment
			}
		}
		footerMenuItems: menuItems(first: 100, where: { location: $footerLocation }) {
			nodes {
				...FooterNavigationMenuItemFragment
			}
		}
		debitSubnavMenuItems: menuItems(first: 100, where: { location: $debitSubnavLocation }) {
			nodes {
				...SubnavMenuItemFragment
			}
		}
		prepaidSubnavMenuItems: menuItems(first: 100, where: { location: $prepaidSubnavLocation }) {
			nodes {
				...SubnavMenuItemFragment
			}
		}
		insuranceSubnavMenuItems: menuItems(first: 100, where: { location: $insuranceSubnavLocation }) {
			nodes {
				...SubnavMenuItemFragment
			}
		}
	}
`;
